export const TEST_ENV_WRAPPER_WIDTH = 800;
export const TEST_ENV_WRAPPER_HEIGHT = 900;

export const MORE_BUTTON_WIDTH = 24;
export const ACTIONS_ROW_PADDING = 12 * 2;
export const WIDTH_WITHOUT_PRICE = ACTIONS_ROW_PADDING + MORE_BUTTON_WIDTH;
export const PRICE_BUTTON_BORDER_AND_PADDING = (11 + 1) * 2;
export const PRICE_BUTTON_MARGIN = 6;
// FIXME
// export const PRICE_BUTTON_CLASS_NAME = classnames(typography.text, typography.sizeTiny, typography.weightNormal);
